import { createFileRoute, Outlet } from '@tanstack/react-router'
import ProjectMenu from '../../../../containers/project-menu'
import { projectSearchSchema } from './search-schemas'
import {
  projectMenuTabOptions,
  viewTypeOptions
} from '../../../../containers/project-menu/constants'
import {
  resolveCompanyProjectsQueryParams,
  resolveMyProjectsQueryParams
} from '../../../../containers/project-menu/list-search-state'
import { myProjectsPageQueryOptions } from '../../../../react-query/project/query/use-get-my-projects-query'
import { projectTreePageQueryOptions } from '../../../../react-query/project/query/use-get-project-tree-query'

function ProjectLayout() {
  return (
    <>
      <ProjectMenu />
      <Outlet />
    </>
  )
}

export const Route = createFileRoute('/_authenticated/project/_projects')({
  validateSearch: projectSearchSchema,
  // Only the params the list queries depend on: opening a modal or a panel on
  // top of the list must not re-run the loader.
  loaderDeps: ({
    search: { view, tab, q, page, size, sort, dir, inactive }
  }) => ({
    view,
    tab,
    q,
    page,
    size,
    sort,
    dir,
    inactive
  }),
  loader: ({ context: { queryClient }, deps }) => {
    // The tile and mobile views read the infinite variant of these lists, which
    // is a different query key — prefetching here would be a wasted request.
    if (
      (deps.view ?? viewTypeOptions.LIST_VIEW) !== viewTypeOptions.LIST_VIEW
    ) {
      return
    }

    const isMyProjects =
      (deps.tab ?? projectMenuTabOptions.MY_PROJECTS) ===
      projectMenuTabOptions.MY_PROJECTS

    // Deliberately not awaited: the fetch starts as soon as the navigation
    // does, but the route still renders immediately so the table shows its own
    // skeleton instead of the full-page pending component.
    queryClient.ensureQueryData(
      isMyProjects
        ? myProjectsPageQueryOptions(resolveMyProjectsQueryParams(deps))
        : projectTreePageQueryOptions(resolveCompanyProjectsQueryParams(deps))
    )
  },
  component: ProjectLayout
})
